import { styled } from '@mui/material/styles';
const RowDeliver = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row'
  },
  alignItems: 'center',
  marginBottom: 5,
  background: '#f8f8f8',
  paddingTop: 5,
  paddingBottom: 5,
  borderRadius: 5
}));

export default RowDeliver;
